import { Modal } from 'antd';
import type { ReactNode } from 'react';
import { sizeToWidth } from './sizeToWidth';

interface DialogModalProps {
  dialog: string | ReactNode;
  title: string;
  size?: 'sm' | 'lg' | 'xl';
  aktionButtonLabel?: ReactNode;
  cancelErrorMessage?: string;
  showActionButton?: boolean;
}

export function presentDialogModal({
  title,
  dialog,
  size = 'sm',
  aktionButtonLabel,
  cancelErrorMessage = 'CANCEL',
  showActionButton = true,
}: DialogModalProps): Promise<void> {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title,
      content: dialog,
      okText: aktionButtonLabel ?? 'OK',
      width: sizeToWidth[size],
      okButtonProps: showActionButton ? undefined : { style: { display: 'none' } },
      onOk: resolve,
      onCancel: () => reject(new Error(cancelErrorMessage)),
    });
  });
}
